var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButterfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.45 37.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f8c64c;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #a82061;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.39,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.13,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.86,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.59,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.32,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.86,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.86,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.86,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.13,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.59,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.59,
    y: 0,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.13,
    y: 0,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.7,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.44,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.17,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.7,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.44,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.17,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.44,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.44,
    y: 29.86,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.44,
    y: 33.59,
    width: 3.73,
    height: 3.73
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 0,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.73,
    y: 0,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.73,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.2,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.73,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.2,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.93,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.73,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.2,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.93,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.66,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.46,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.73,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.2,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.93,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.66,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.73,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.2,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.93,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.73,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.2,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.93,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.73,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.2,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.93,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.6,
    y: 29.86,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.87,
    y: 29.86,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.33,
    y: 29.86,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.6,
    y: 33.59,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.6,
    y: 3.73,
    width: 3.73,
    height: 3.73
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.25,
    y: 0,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.98,
    y: 0,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.71,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.25,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.98,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.52,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.71,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.25,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.98,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.52,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.79,
    y: 7.46,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.71,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.25,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.98,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.52,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.79,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.05,
    y: 11.2,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.71,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.25,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.98,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.52,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.79,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.05,
    y: 14.93,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.71,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.25,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.98,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.52,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.79,
    y: 18.66,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.71,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.25,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.98,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.52,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.79,
    y: 22.39,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.71,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.25,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.98,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.52,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.79,
    y: 26.13,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.12,
    y: 29.86,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.85,
    y: 29.86,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.38,
    y: 29.86,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.12,
    y: 33.59,
    width: 3.73,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.12,
    y: 3.73,
    width: 3.73,
    height: 3.73
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly);
export default __webpack_public_path__ + "static/media/butterfly.c7fac70f04b73741e4ba2af0d07a9ff0.svg";
export { ForwardRef as ReactComponent };